<template>
  <div>

    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="container-fluid">
      <div class="spinner-cover" v-if="isLoading">
        <div class="spinner"></div>
      </div>

      <template v-if="usercan('editor')">
        <div class="row navbar-dark bg-dark mt-3">
          <div class="col-xl-12 col-lg-12 col-md-12 main-tabs">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" id="tab-1" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1"
                   aria-selected="true">Allgemein</a>
              </li>
              <li class="nav-item d-none" role="presentation">
                <a class="nav-link" id="tab-2" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2"
                   aria-selected="false">Fotodokumentation</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-3" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3"
                   aria-selected="false">Schlagworte</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-4" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4"
                   aria-selected="false">Bautagebuch</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-5" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5"
                   aria-selected="false">Benutzer</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="tab-6" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6"
                   aria-selected="false">Gewerke</a>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
    <div id="main" class="skybackground pt-3 pb-0">
      <div class="tab-content main-tabs " id="myTabContent">
        <template v-if="usercan('editor')">
          <general/>
          <photoDocumentation/>
          <catchwords/>
          <constructionDiary/>
          <user/>
          <trades/>
        </template>
      </div>


      <div class="row" v-if="!usercan('editor')">
        <div class="col-12">

          <p class="bg-danger font14 text-center d-block">Sie verfügen nicht über die nötigen Rechte</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import general from './components/General'
import photoDocumentation from './components/PhotoDocumentation'
import catchwords from './components/Catchwords'
import constructionDiary from './components/ConstructionDiary'
import user from './components/Users'
import trades from './components/Trades'

export default {
  name: 'index',
  components: {
    general, photoDocumentation, catchwords, constructionDiary, user, trades
  },
  created () {
    this.$store.dispatch("getProjectDetails", this.$route.params.id)
  },
  mounted () {
    this.$store.commit("settingsModuleSetLoading", false)
  },
  computed: {
    isLoading () {
      return this.$store.state.appSettings.is_loading
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/appSetting/index.vue